// Single source of truth for tournament games and modes.
// Add new entries here — admin selects and public badges pick them up automatically.

export const GAMES = ['csgo', 'cs2', 'momentum-mod', '1.6kz'];

export const GAME_LABELS = {
  csgo: 'CS:GO',
  cs2: 'CS2',
  'momentum-mod': 'Momentum Mod',
  '1.6kz': '1.6 KZ',
};

export const DEFAULT_GAME = 'cs2';

export const gameLabel = (value) => GAME_LABELS[value] || value;

// Game where mode does not apply (single mode by definition).
export const GAME_WITHOUT_MODE = '1.6kz';

export const MODES = ['KZT', 'VNL', 'SKZ', 'CKZ'];

export const MODE_LABELS = {
  KZT: 'KZT',
  VNL: 'VNL',
  SKZ: 'SKZ',
  CKZ: 'CKZ',
  '1.6kz': '1.6 KZ',
};

export const DEFAULT_MODE = 'KZT';

// Tailwind border + text colour classes for mode badges.
export const MODE_TINTS = {
  KZT: 'border-heat/60 text-heat',
  VNL: 'border-warning/60 text-warning',
  SKZ: 'border-info/60 text-info',
  CKZ: 'border-accent/60 text-accent',
  '1.6kz': 'border-primary/60 text-primary',
};

export const modeLabel = (value) => MODE_LABELS[value] || value;

// Resolves which modes a tournament uses. Reads `modes: string[]` if present,
// falls back to the legacy single-string `mode` for older tournaments. Returns
// [] when the game has no mode concept (e.g. 1.6kz) or nothing is set.
export const getTournamentModes = (tournament) => {
  if (!tournament) return [];
  if (tournament.game === GAME_WITHOUT_MODE) return [];
  if (Array.isArray(tournament.modes) && tournament.modes.length > 0) {
    return tournament.modes.filter((m) => MODES.includes(m));
  }
  if (tournament.mode && MODES.includes(tournament.mode)) return [tournament.mode];
  return [];
};
